module.exports = __webpack_public_path__ + "img/RightcenterRobot.2e1f6c8b.png";